import * as React from 'react';
import * as style from './style.css';
import { jsx as _jsx } from "react/jsx-runtime";
export const ModalLayout = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: style['content'],
    "data-testid": "NewbuildingLayoutOffersModal",
    children: children
  });
};